import {Injectable} from '@angular/core';
import { environment } from '../../environments/environment';
import {HttpClient, HttpContext, HttpParams, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {CustomHttpResponse} from '../model/custom-http-response';
import { CACHE_ENABLED } from '../interceptor/cache.interceptor';

@Injectable({
  providedIn: 'root'
})
export class BundleService {
  host = environment.apiUrl;

  constructor(private http: HttpClient) {
  }

  getAllBundle(id?:string): Observable<HttpResponse<CustomHttpResponse>> {
    let params = new HttpParams();

    if (id) {
      params = params.append('id', id);
    }
    return this.http.get<CustomHttpResponse>(
      `${this.host}/v1/public/products/bundles`,
      {
        observe: 'response',
        params,
        context: new HttpContext().set(CACHE_ENABLED, true)
      }
    )
  }

  getBundleById(id: string): Observable<HttpResponse<CustomHttpResponse>> {
    return this.http.get<CustomHttpResponse>(
      `${this.host}/v1/public/products/bundles/${id}`,
      {
        observe: 'response',
        context: new HttpContext().set(CACHE_ENABLED, true)
      }
    )
  }

  getBundleBySlug(id: string): Observable<HttpResponse<CustomHttpResponse>> {
    return this.http.get<CustomHttpResponse>(
      `${this.host}/v1/public/products/bundles/slug/${encodeURI(id)}`,
      {
        observe: 'response',
        context: new HttpContext().set(CACHE_ENABLED, true)
      }
    )
  }
}
